export default __webpack_public_path__ + "static/media/mindmap_04.1037a093.png";